// import {
//   editCartItemMutation,
//   removeFromCartMutation,
// } from '@/helpers/big-commerce/mutations/cart';
import { getCartQuery } from '@/helpers/big-commerce/queries/cart';
import { getProductByIdQuery } from '@/helpers/big-commerce/queries/product';

import { BIGCOMMERCE_GRAPHQL_API_ENDPOINT } from './constants';
import { createCartRedirectUrl } from './server/cart';

export const memoizedCartRedirectUrl = (() => {
  const localCache = {
    activeCartId: null,
    data: null,
  };

  return async (cartId) => {
    if (localCache.activeCartId !== cartId || !localCache.data) {
      const data = await createCartRedirectUrl(cartId);

      localCache.activeCartId = cartId;
      localCache.data = data;

      return data;
    }

    return localCache.data;
  };
})();

export const findProductVariantWithOption = ({
  product,
  choices,
  option = null,
  value = null,
}) => {
  if (!product) {
    return null;
  }

  return product.variants?.edges?.find?.((variant) => {
    return Object.keys(choices)?.every?.((choiceId) => {
      const parsedChoiceId = parseInt(choiceId, 10);

      return variant?.node?.options?.edges?.find?.((optionItem) => {
        return (
          optionItem?.node?.entityId === parsedChoiceId &&
          optionItem?.node?.values?.edges?.find?.((valueItem) => {
            return (
              valueItem?.node?.entityId ===
              (option?.entityId &&
              option?.entityId === optionItem?.node?.entityId
                ? value.entityId
                : choices[choiceId])
            );
          })
        );
      });
    });
  })?.node;
};

export const findProductVariant = (product, choices) => {
  return findProductVariantWithOption({
    product,
    choices,
  });
};

/**
 * @param {Object} params
 * @param {Object<string, string>} [params.headers]
 * @param {string} [params.query]
 * @param {Object} [params.variables]
 * @param {RequestCache} [params.cache]
 */
const bigCommerceFetch = async ({ headers = {}, query, variables, cache }) => {
  try {
    const result = await fetch(BIGCOMMERCE_GRAPHQL_API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${process.env.BIGCOMMERCE_STOREFRONT_API_TOKEN}`,
        ...headers,
      },
      body: JSON.stringify({
        ...(query && { query }),
        ...(variables && { variables }),
      }),
      cache,
      next: cache
        ? undefined
        : process.env.NODE_ENV === 'development'
          ? {
              revalidate: 0,
            }
          : {
              // tags: ['big-commerce'],

              // 1 hour
              // revalidate: 3600,

              // 15 minutes
              revalidate: 900,
            },
    });

    const body = await result.json();

    if (body.errors) {
      throw body.errors[0];
    }

    return {
      status: result.status,
      body,
    };
  } catch (error) {
    throw {
      error,
      query,
    };
  }
};

/**
 * Queries
 */

export const getProductById = async (productId) => {
  try {
    const res = await bigCommerceFetch({
      query: getProductByIdQuery,
      variables: {
        productId:
          typeof productId === 'string' ? parseInt(productId, 10) : productId,
      },
    });

    return res.body.data.site.product;
  } catch (error) {
    console.error(error.error);

    return null;
  }
};

export const getCart = async (sessionToken) => {
  const res = await bigCommerceFetch({
    headers: {
      'X-Session': sessionToken,
    },
    query: getCartQuery,
    cache: 'no-store',
  });

  // Old carts becomes `null` when you checkout.
  if (!res.body.data.cart) {
    return undefined;
  }

  return res.body.data.cart;
};

/**
 * Mutations
 */

// export const addToCart = async ({
//   sessionToken = '',
//   productId,
//   quantity,
//   options,
// }) => {
//   const res = await bigCommerceFetch({
//     headers: {
//       'X-Session': sessionToken,
//     },
//     query: addToCartMutation,
//     variables: {
//       productId,
//       quantity,
//       options,
//     },
//     cache: 'no-store',
//   });

//   return res.body.addToCartItem;
// };

export const removeFromCart = async (sessionToken, lineIds) => {
  // const res = await bigCommerceFetch({
  //   headers: {
  //     'X-Session': sessionToken,
  //   },
  //   query: editCartItemMutation,
  //   variables: {
  //     lineIds,
  //   },
  //   cache: 'no-store',
  // });
  // return res.body.data.cartLinesRemove.cart;
};

export const updateCart = async (sessionToken, lines) => {
  // const res = await bigCommerceFetch({
  //   headers: {
  //     'X-Session': sessionToken,
  //   },
  //   query: removeFromCartMutation,
  //   variables: {
  //     lines,
  //   },
  //   cache: 'no-store',
  // });
  // return res.body.data.cartLinesUpdate.cart;
};
